export default __webpack_public_path__ + "static/media/IFS.40576bcb.jpg";